import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { initHeroParallax } from '@app/hero-parallax.js';

gsap.registerPlugin(ScrollTrigger);

const hero = document.querySelector('.wp-block-pulp-homepage-hero');
if (hero) {
    // ── Mouse parallax + overlay layer entrance (shared) ──────────────────
    initHeroParallax({
        selector: '.wp-block-pulp-homepage-hero',
        extraMouseTargets: [
            { selector: '.hero-sun', xMult: -0.2, yMult: -0.15, lerp: 0.09, live: true },
            { selector: '.hero-birds', xMult: -0.25, yMult: -0.18, lerp: 0.07, live: true },
        ],
        onEntranceReady(h, tl) {
            const sunGraphic = h.querySelector('.hero-sun-graphic');
            const birdGraphics = [1, 2, 3]
                .map(n => h.querySelector(`.hero-birds-graphic-${n}`))
                .filter(Boolean);

            if (sunGraphic) sunGraphic.style.opacity = '0';
            birdGraphics.forEach(g => { g.style.opacity = '0'; });

            tl.call(() => sunGraphic?.classList.add('is-entering'), null, '>-0.5');
            tl.call(() => birdGraphics.forEach(g => g?.classList.add('is-entering')), null, '<0.55');
        },
    });

    // ── Homepage-specific scroll animations ──────────────────────────────
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const triggerDefaults = { trigger: hero, start: 'top top', end: 'bottom top', scrub: true };

        const moon = hero.querySelector('.hero-moon');
        const sun = hero.querySelector('.hero-sun');
        const birds = hero.querySelector('.hero-birds');
        const layers = hero.querySelectorAll('.hero-layer');

        // Per-layer data-speed parallax
        layers.forEach(layer => {
            const speed = parseFloat(layer.dataset.speed) || 0;
            if (speed) gsap.to(layer, { yPercent: -speed, ease: 'none', scrollTrigger: { ...triggerDefaults } });
        });

        if (sun) gsap.to(sun, { yPercent: -60, ease: 'none', scrollTrigger: { ...triggerDefaults } });
        if (birds) gsap.to(birds, { yPercent: 80, ease: 'none', scrollTrigger: { ...triggerDefaults } });

        // ── Scroll reveal — moon ───────────────────────────────────────
        if (moon) {
            gsap.set(moon, { y: () => -(moon.offsetHeight) });
            gsap.fromTo(moon,
                { y: () => -(moon.offsetHeight) },
                {
                    y: () => hero.offsetHeight * 1.1 - moon.offsetHeight - 20,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: hero,
                        start: 'top top',
                        end: '35% top',
                        scrub: 0.1,
                        invalidateOnRefresh: true,
                    },
                }
            );
        }
    }
}
